import { Route } from "react-router-dom"
import { lazy } from "react"


const Booking = lazy(() => import("../features/user-booking/MyBooking"))
const ClientSettings = lazy(() => import("../features/client-settings/ClientSettings"))
const ClientProfile = lazy(() => import("../features/client-profile/ClientProfile"))
const MyFavorites = lazy(() => import("../features/user-favourites/MyFavorites"))
const ClientDashboard = lazy(() => import("../features/user-dashboard/ClientDashboard"))
const MessagesPage = lazy(() => import("../features/messages/MessagesPage"))
export default function ClientRoutes() {
  return (
    <>
      <Route path="/user/my-bookings" element={<Booking />} />
      <Route path="/user/settings" element={<ClientSettings />} />
      <Route path="/user/profile" element={<ClientProfile />} />
      <Route path="/user/dashboard" element={<ClientDashboard />} />
      <Route path="/user/my-favorites" element={<MyFavorites />} />
      <Route path="/messages/:artisanId" element={<MessagesPage />} />
      {/* <Route path="/user/my-posts" element={<MyPosts />} /> */}
    </>
  )
}
